@import "@/scss/use-bootstrap-mixins";

.descriptor {
  min-height: 250px;
  margin: 0 auto;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px 18px;

  @include media-breakpoint-up(lg) {
    background-color: transparent;
    display: flex;
    justify-content: space-between;
  }

  .desktop_info {
    display: none;
    background-color: #f5f5f5;
    border-radius: 14px;
    padding: 26px 30px 35px 30px;

    @include media-breakpoint-up(lg) {
      display: block;
      width: 400px;
      align-self: center;
    }

    .desktop_header {
      display: flex;
      gap: 10px;

      .left {
        flex-grow: 1;
        .stats {
          display: flex;
          align-items: center;
          span:first-child {
            font-size: 36px;
            font-weight: 600 !important;
            opacity: 0.9;
            color: #000 !important;
            margin: 0;

            &.descriptorTitleLabel {
              font-size: 25px !important;
            }
            &.descriptorAreaLabel {
              font-size: 25px !important;
            }
            &.descriptorDimensionsLabel {
              font-size: 25px !important;
            }
          }
          span:last-child {
            background-color: #5e5e5e;
            color: #fff !important;
            font-size: 10px;
            margin-left: 8px;
            padding: 3px 11px;
            font-weight: 600;
            border-radius: 20px;
          }
        }
        span {
          font-size: 12px;
          font-weight: 600;
        }
        .sizes_text {
          font-size: 10px;
          font-weight: 600;
        }
      }

      .right {
        flex-shrink: 0;
        .desktop_button {
          .arrow {
            display: initial !important;
            color: $textColorOnPrimary;
            stroke: $textColorOnPrimary;
            stroke-width: 2px;
            margin-top: -3px;
            margin-right: 1px;
            margin-left: 4px;
            height: 10px;
          }
        }
      }
    }
    .desktop_body {
      margin-top: 30px;
      span {
        margin: 0;
        font-size: 16px;
        font-weight: 600 !important;
        color: #000 !important;
      }
      p {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        color: #000 !important;
      }
      .ideal_for {
        font-size: 13px;
        margin-top: 12px;
        margin-bottom: 8px;
        font-weight: 600;
        color: #000 !important;
      }
    }
  }

  .header {
    display: flex;
    align-items: start;
    margin-bottom: 4px !important;
    gap: 10px;

    @include media-breakpoint-up(sm) {
      display: flex;
    }

    @include media-breakpoint-up(lg) {
      display: none;
    }

    .left {
      flex-grow: 1;

      margin-bottom: 4px;

      @include media-breakpoint-up(sm) {
        margin-bottom: initial;
      }

      .stats {
        display: flex;
        align-items: center;
        gap: 10px;

        @include media-breakpoint-up(sm) {
          display: flex;
        }

        span:first-child {
          font-weight: 600 !important;
          font-size: 36px;
          margin: 0;
          color: #000 !important;

          &.descriptorTitleLabel {
            font-size: 18px !important;
          }
          &.descriptorAreaLabel {
            font-size: 18px !important;
          }
          &.descriptorDimensionsLabel {
            font-size: 18px !important;
          }
        }

        span:last-child {
          background-color: #5e5e5e;
          color: #fff !important;
          font-size: 10px;
          // margin-left: 8px;
          padding: 1px 8px;
          border-radius: 20px;
          display: inline-block;

          @include media-breakpoint-up(sm) {
            margin-left: 8px;
          }
        }
      }

      span {
        font-size: 11px;
        font-weight: 500 !important;
        display: block;
      }
    }

    .right {
      button {
        padding: 10px 24px;

        @include media-breakpoint-down(md) {
          padding: 10px 5px;
          min-width: 140px;
        }
      }
    }
  }

  .icon {
    width: 100%;

    @include media-breakpoint-down(lg) {
      height: 300px;
      text-align: center;
    }

    @include media-breakpoint-up(lg) {
      width: 375px;
      height: 375px;

      display: flex;
      align-items: center;
      padding: 0 24px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;

      @include media-breakpoint-up(lg) {
      }
    }
  }

  .mobile_buttons {
    display: flex;
    justify-content: space-between;

    @include media-breakpoint-up(lg) {
      display: none;
    }

    button {
      max-width: 47px;
      border: 0;
      background-color: transparent;
      text-align: center;
      padding: 0;
      height: 40px !important;
      width: 40px !important;
      border: 1px solid #000;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        path {
          stroke: #000;
        }
      }
    }
  }

  .footer {
    display: block;
    @include media-breakpoint-up(lg) {
      display: none;
    }

    span {
      display: block;
    }

    span:first-child {
      font-size: 16px;
      font-weight: 600 !important;
      margin: 0;
      color: #000 !important;
    }

    span:last-child {
      font-size: 14px;
      font-weight: 400;
      color: #000 !important;
    }
  }
}

.carousel_descriptor {
  // padding: 12px 18px;
  height: 100%;
  width: 100%;
  min-width: 50%;
  transition: all 0.4s;
  align-items: center;
  .header {
    display: none !important;
  }
  .icon {
    // width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    height: 100%;

    @include media-breakpoint-up(lg) {
      flex-shrink: 1;
    }

    img {
      // max-width: 100%;
      height: 100%;
      object-fit: contain;
      max-width: 154px;
    }
  }
  .active {
    transition: all 0.4s;
    display: none;
    margin-left: 10px;
    @include media-breakpoint-up(lg) {
      flex-grow: 1;
      flex-wrap: wrap;
      align-items: center;
    }
    .sizes {
      color: #000;
      font-size: 10px;
      font-weight: 600;
    }
    .stats {
      display: flex;
      align-items: center;
      width: 100%;

      span:first-child {
        font-weight: 600 !important;
        font-size: 36px;
        margin: 0;
        color: #000 !important;

        &.descriptorTitleLabel {
          font-size: 25px !important;
        }
        &.descriptorAreaLabel {
          font-size: 25px !important;
        }
        &.descriptorDimensionsLabel {
          font-size: 25px !important;
        }
      }

      span:last-child {
        background-color: #5e5e5e;
        color: #fff !important;
        font-size: 10px !important;
        margin-left: 8px;
        padding: 1px 8px;
        border-radius: 20px;
      }
    }
  }
  .footer {
    display: none !important;
  }

  @include media-breakpoint-up(lg) {
    display: flex;
    align-items: center;
  }
}

.hidden {
  display: none;
}

.mobile {
  display: block;

  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}

.desktop {
  display: none;

  @include media-breakpoint-up(lg) {
    display: block;
    margin-bottom: 35px;
  }
}
